import React from 'react';
import phoneIcon from '../assets/images/phone-enquiry.png';
import mailIcon from '../assets/images/mail-enquiry.png';
import locationIcon from '../assets/images/location-icon.png';
import './CustomerEnquiryBanner.scss';

const CustomerEnquiryBanner = (props) => {
  return (
    <div className="customer-enquiry-banner">
      <img
        src={props?.fields?.EnquiryWebImage?.value?.src}
        alt="Enquiry And Customer Support"
        className="customer-enquiry-banner-desktop"
      />
      <img
        src={props?.fields?.EnquiryMobileImage?.value?.src}
        alt="Enquiry And Customer Support"
        className="customer-enquiry-banner-mobile"
      />
      <div className="customer-enquiry-content">
        <h3>{props?.fields?.EnquiryText?.value}</h3>
        <ul>
          <li>
            <span className="enquiry-icon" aria-hidden="true">
              <img src={phoneIcon} alt="" />
            </span>
            <a href={`tel:${props?.fields?.EnquiryPhone?.value}`} className="enquiry-phone">
              {props?.fields?.EnquiryPhone?.value}
            </a>
          </li>
          <li>
            <span className="enquiry-icon" aria-hidden="true">
              <img src={locationIcon} alt="" />
            </span>
            <span className="location-icon">
              <div
                dangerouslySetInnerHTML={{
                  __html: props?.fields?.EnquiryAddress?.value,
                }}
              />
            </span>
          </li>
          <li>
            <span className="enquiry-icon" aria-hidden="true">
              <img src={mailIcon} alt="" />
            </span>
            <a href={`mailto:${props?.fields?.EnquiryEmail?.value}`}>
              {props?.fields?.EnquiryEmail?.value}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CustomerEnquiryBanner;
